<template>
	<div class="row">
		<div class="col-12">
			<div class="input-group mb-3">
				<input type="file" class="" accept=".jpg, .jpeg, .png, .pdf" @change="setImage" /> 
			</div>
			<div class="progress" v-if="loadProgress >= 0">
				<div class="progress-bar" :style="`width: ${loadProgress}%;`" role="progressbar" aria-valuenow="loadProgress" aria-valuemin="0" aria-valuemax="100">{{ Math.ceil(loadProgress) }}%</div>
			</div>
		</div>
	</div>
</template>

<script>
    import Vue from 'vue'
	import VueToast from 'vue-toast-notification'
	import 'vue-toast-notification/dist/theme-sugar.css'
    Vue.use(VueToast)
	const fb = require("../firebaseConfig")
	export default {
		name: 'VaxCardUploader',
		filters: { },
        props:["docId", "currentImg", "folder", "type"],
		components: { },
		computed:{
            userProfile(){
                return this.$store.state.userProfile
            }
		},
		data(){
			return{
				isBusy: false,
                imgSrc: this.$store.state.imgPlaceholder,
                cropImg: '',
                data: null,
                loadProgress: '0',
			}
		},
		methods:{
            setImage(e) {
                this.isBusy = true
				//var fileName =   e.target.files[0].name
                var file =   e.target.files[0]
				var extension = file.type
				var imgFileName = `${this.userProfile.fname} ${this.userProfile.lname} ${Math.floor(Date.now()/1000) }.${extension.replace(/(.*)\//g, '')}`

                var metadata = {
                    cacheControl: "public,max-age=300",
                }

				var uploadTask = fb.storageRef.child(`vaxxcards/${imgFileName}`).put(file, metadata)    
				//var uploadTask = fb.storageRef.child(`${this.userProfile.UUID}/vax_card/${fileName}`).put(file, metadata)                   

				uploadTask.on(fb.firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
					var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
					// console.log('Upload is ' + progress + '% done')
					this.loadProgress = progress
					switch (snapshot.state) {
						case fb.firebase.storage.TaskState.PAUSED: 
							break
						case fb.firebase.storage.TaskState.RUNNING: 
							break
					}
				}, 
				(error) => {
					switch (error.code) {
					case 'storage/unauthorized':
						Vue.$toast.error("There was error uploding your file.", {position:"top"})
						break
					case 'storage/canceled':
						Vue.$toast.error("There was error uploding your file.", {position:"top"})
						break
					case 'storage/unknown':
						Vue.$toast.error("There was error uploding your file.", {position:"top"})
						break
					}
					this.isBusy = false
				}, 
				() => {
					uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
						this.$emit("uploadComplete", {imgFile: downloadURL, imgFileName:`${imgFileName}`})
						this.resetImgUploader()
					})
				})
            },
            btnEditImageClick(){
                document.getElementById("fileInput").click()
			},
            btnCancelUploadClick(){
                document.getElementById("fileInput").value = null
            },
            btnSaveUploadClick(){
                this.loadProgress = 0
                this.isBusy = true
                this.cropImg = this.$refs.cropper.getCroppedCanvas()
                this.imgSrc = this.cropImg.toDataURL('image/jpeg')

                let fileName =   document.getElementById("fileInput").files[0].name

                let metadata = {
                    cacheControl: "public,max-age=300",
                }
                this.cropImg.toBlob((blob)=>{
                    var uploadTask = fb.storageRef.child(`vax_card/${this.userProfile.fname} ${this.userProfile.lname} -${Math.floor(Date.now()/1000)}`).put(blob, metadata)

                    uploadTask.on(fb.firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
                        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                        //console.log('Upload is ' + progress + '% done')
                        this.loadProgress = progress
                        switch (snapshot.state) {
                            case fb.firebase.storage.TaskState.PAUSED: 
                                break
                            case fb.firebase.storage.TaskState.RUNNING: 
                                break
                        }
                    }, 
                    (error) => {
                        switch (error.code) {
                        case 'storage/unauthorized':
                            Vue.$toast.error("There was error uploding your file.", {position:"top"})
                            break
                        case 'storage/canceled':
                            Vue.$toast.error("There was error uploding your file.", {position:"top"})
                            break
                        case 'storage/unknown':
                            Vue.$toast.error("There was error uploding your file.", {position:"top"})
                            break
                        }
                        this.isBusy = false
                    }, 
                    () => {
                        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
							this.$emit("uploadComplete", {imgFile: downloadURL, imgFileName:`${this.userProfile.UUID}/vax_card/${fileName}`})
							this.resetImgUploader()
                        })
                    })
                })
            },
            resetImgUploader(){
                //document.getElementById("fileInput").value = null
                this.isBusy = false
            }
		},
		mounted(){
            
        }
	}
</script>
